import axiosInstance from './axios';

export const brandService = {
  getBrands: async (params = {}) => {
    const response = await axiosInstance.get('/brands', { params });
    return response.data;
  },

  getBrand: async (id) => {
    const response = await axiosInstance.get(`/brands/${id}`);
    return response.data;
  },

  createBrand: async (brandData) => {
    const response = await axiosInstance.post('/brands', brandData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  updateBrand: async (id, brandData) => {
    // Laravel doesn't parse multipart/form-data on PUT — use POST + _method override
    if (brandData instanceof FormData) {
      brandData.append('_method', 'PUT');
    }
    const response = await axiosInstance.post(`/brands/${id}`, brandData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteBrand: async (id) => {
    const response = await axiosInstance.delete(`/brands/${id}`);
    return response.data;
  },
};
